import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import {ButtonGroup, Button, Form, Modal, Dropdown, DropdownButton, Col, Row } from 'react-bootstrap';

import CheckBox from '../../../components/Checkbox/Checkbox';
import { CHART_TYPES } from '../../../components/Filter/FilterActions';

import { handleError, getViews, createSetting } from '../WallboardsActions';

import Close from '../../../assets/img/close.svg';
import openInNewIcon from '../../../assets/img/open-in-new.svg';
import SaveIcon from '../../../assets/img/save.svg';

import './WallboardConfig.scss';

const defaultState = {
  intervals: [
    { text: 'Off', value: 0 },
    { text: '30 sec', value: 30 },
    { text: '1 min', value: 60 },
    { text: '2 min', value: 120 },
    { text: '5 min', value: 300 }
  ],
  views: [],
  readOnly: false,
  allSelected: true,
  model: {
    shortUrl: '',
    rotationInterval: 30,
    selectedView: 'default',
    name: '',
    enabledCharts: {
      overview: true,
      cfd: true,
      ctsp: true,
      ctb: true,
      cth: true,
      cta: true,
      trc: true,
      th: true,
      fe: true,
      ddp: true,
      mc: true,
      mct: true
    }
  }
};

export class WallboardConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultState,
      isOpened: props.visible
    };
  }

  componentDidMount() {
    if (this.props.dashboardId) {
      this.props.getViews(this.props.dashboardId);
      this.checkIfAllSelected();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.dashboardId !== prevProps.dashboardId) {
      this.props.getViews(this.props.dashboardId);
    }

    if (!_.isEqual(prevState.model.enabledCharts, this.state.model.enabledCharts)) {
      this.checkIfAllSelected();
    }
  }

  onButtonClick = () => {
    if (!this.state.isOpened) {
      const model = this.props.model;
      this.setState({
        ...defaultState,
        isOpened: true,
        readOnly: model && model.name === 'Default',
        model: model ? { ...model } : { ...defaultState.model }
      });
    }
  };

  onClose = (event, propagate) => {
    if (event) {
      event.stopPropagation();
    }
    this.setState({
      isOpened: false
    });
    !!this.props.onClose && !!propagate && this.props.onClose();
  };

  checkIfAllSelected = () => {
    const all = _.every(this.state.model.enabledCharts, c => {
      return !!c;
    });
    this.setState({ allSelected: all });
  };

  handleCheck = e => {
    if (e.name === 'all') {
      const charts = {};
      CHART_TYPES.map(c => {
        charts[c] = e.checked;
      });

      this.setState({
        allSelected: e.checked,
        model: {
          ...this.state.model,
          enabledCharts: charts
        }
      });

      return;
    }

    this.setState({
      model: {
        ...this.state.model,
        enabledCharts: {
          ...this.state.model.enabledCharts,
          [e.name]: e.checked
        }
      }
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const { model } = this.state;

    const allChartsDisabled = Object.values(model.enabledCharts).every(c => c === false);
    if (allChartsDisabled) {
      this.props.handleError('Select at least one chart');
      return false;
    }

    this.props.createSetting(this.props.dashboardId, this.formatModel(model));
    this.onClose();
  };

  formatModel = model => {
    return {
      _id: model._id,
      name: model.name,
      enabledCharts: model.enabledCharts,
      selectedView: model.selectedView,
      rotationInterval: model.rotationInterval
    };
  };

  renderDropdownValue = value => {
    const option = _.find(this.state.intervals, { value });
    if (option) {
      return option.text;
    } else {
      return this.state.intervals[0].text;
    }
  };

  renderViewValue = value => {
    let option = _.find(this.props.views, { _id: value });
    if (option) {
      return option.name;
    }
    option = _.find(this.props.views, { _id: 'default' });
    if (option) {
      return option.name;
    }
  };

  selectView = id => {
    this.setState({
      model: {
        ...this.state.model,
        selectedView: id
      }
    });
  };

  selectInterval = id => {
    this.setState({
      model: {
        ...this.state.model,
        rotationInterval: id
      }
    });
  };

  handleInput = e => {
    this.setState({
      model: {
        ...this.state.model,
        name: e.target.value
      }
    });
  };

  render() {
    const { model, isOpened, readOnly } = this.state;
    const { views } = this.props;

    var modal = (
      <Modal
        keyboard={false}
        backdrop={'static'}
        show={isOpened}
        onHide={this.onClose}
        className='wallboard-settings-modal'>
        <Modal.Header>
          <Modal.Title>Wallboard settings</Modal.Title>
          <Button className="btn-close" onClick={this.onClose}>
            <img src={Close} alt="close" />
          </Button>
        </Modal.Header>
        <Modal.Body className='form_content'>
          <Form onSubmit={this.handleSubmit}>
            <Form.Group controlId="name" className='display_name_input'>
              <Form.Label>Wallboard name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={model.name}
                autoComplete="off"
                readOnly={readOnly}
                onChange={this.handleInput}
              />
            </Form.Group>

            {model._id && (
              <Form.Group controlId="url" className='display_url_input'>
                <label className="form-label">
                  Display URL
                </label>
                <div>
                  <Form.Control type="text" name="url" value={model.shortUrl} readOnly />
                  <a href={model.shortUrl} target="_blank" className='btn btn-md btn-secondary'>
                    <img src={openInNewIcon} alt="#" />
                    Open
                  </a>
                </div>
                <div className="notification">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM11 9H13V7H11V9Z"
                      fill="#FEFEFE"
                    />
                  </svg>
                  This link is public. Anyone with it can view your wallboard without logging in. Perfect for TV screens, office displays, and shared portals.
                </div>
              </Form.Group>
            )}

            { views && views.length && (<Form.Group controlId="interval" className='select_interval_input'>
              <label>Apply dashboard view</label>
              <DropdownButton
                id="interval"
                className="form-control-dropdown"
                title={this.renderViewValue(model.selectedView)}
              >
                {views &&
                  views.map((v, i) => (
                    <Dropdown.Item key={i} onClick={() => this.selectView(v._id)}>
                      {v.name}
                    </Dropdown.Item>
                  ))}
              </DropdownButton>
            </Form.Group>)}

            <Form.Group controlId="charts" className='select_graphs_content'>
              <Form.Label>
                Select graphs to display
                <div className='btn btn-secondary btn-md'>
                  <CheckBox
                    id="all"
                    name="all"
                    label="Select all"
                    checked={this.state.allSelected}
                    onChange={this.handleCheck} />
                </div>
              </Form.Label>
              <div className='select_list_check'>
                  <CheckBox
                    id="overview"
                    className='overview-check'
                    name="overview"
                    label="Overview"
                    checked={model.enabledCharts.overview}
                    onChange={this.handleCheck}
                  />
                  <CheckBox
                    id="cfd"
                    className='cfd-check'
                    name="cfd"
                    label="Cumulative Flow Diagram"
                    checked={model.enabledCharts.cfd}
                    onChange={this.handleCheck}
                  />
                  <CheckBox
                    id="ctsp"
                    className='ctsp-check'
                    name="ctsp"
                    label="Cycle Time Scatterplot"
                    checked={model.enabledCharts.ctsp}
                    onChange={this.handleCheck}
                  />
                  <CheckBox
                    id="ctb"
                    className='ctb-check'
                    name="ctb"
                    label="Cycle Time Breakdown Chart"
                    checked={model.enabledCharts.ctb}
                    onChange={this.handleCheck}
                  />
                  <CheckBox
                    id="cth"
                    className='cth-check'
                    name="cth"
                    label="Cycle Time Histogram"
                    checked={model.enabledCharts.cth}
                    onChange={this.handleCheck}
                  />
                  <CheckBox
                    id="cta"
                    className='cta-check'
                    name="cta"
                    label="Aging Chart"
                    checked={model.enabledCharts.cta}
                    onChange={this.handleCheck}
                  />
                  <CheckBox
                    id="trc"
                    className='trc-check'
                    name="trc"
                    label="Throughput Run Chart"
                    checked={model.enabledCharts.trc}
                    onChange={this.handleCheck}
                  />
                  <CheckBox
                    id="th"
                    className='th-check'
                    name="th"
                    label="Throughput Histogram"
                    checked={model.enabledCharts.th}
                    onChange={this.handleCheck}
                  />
                  <CheckBox
                    id="fe"
                    className='fe-check'
                    name="fe"
                    label="Flow Efficiency Chart"
                    checked={model.enabledCharts.fe}
                    onChange={this.handleCheck}
                  />
                  <CheckBox
                    id="ddp"
                    className='ddp-check'
                    name="ddp"
                    label="Due Date Performance Chart"
                    checked={model.enabledCharts.ddp}
                    onChange={this.handleCheck}
                  />
                  <CheckBox
                    id="mc"
                    className='mc-check'
                    name="mc"
                    label="Monte Carlo: Delivery Date"
                    checked={model.enabledCharts.mc}
                    onChange={this.handleCheck}
                  />
                  <CheckBox
                    id="mct"
                    className='mct-check'
                    name="mct"
                    label="Monte Carlo: Number of Tasks"
                    checked={model.enabledCharts.mct}
                    onChange={this.handleCheck}
                  />
              </div>
            </Form.Group>

            <Form.Group controlId="interval" className='select_interval_input'>
              <Form.Label>Rotation interval</Form.Label>
              <ButtonGroup id="interval">
                {this.state.intervals.map((s, i) => (
                  <Button variant='secondary' size='md' key={i} onClick={() => this.selectInterval(s.value)} className={this.renderDropdownValue(model.rotationInterval) == s.text && 'active'}>
                    {s.text}
                  </Button>
                ))}
              </ButtonGroup>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
        <Button variant='primary' type="submit" onClick={this.handleSubmit}>
            <img src={SaveIcon} alt="" />
            {this.props.isLoading ? 'Loading...' : model._id ? 'Update wallboard ' : 'Create wallboard'}
          </Button>
          <Button variant='secondary' onClick={this.onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );

    var content;
    if (this.props.children) {
      var btn = React.Children.only(this.props.children);
      content = React.cloneElement(
        btn,
        {
          ...btn.props,
          onClick: this.onButtonClick
        },
        btn.props.children,
        modal
      );
    } else {
      content = (
        <Button onClick={this.onButtonClick} style={this.props.style}>
          {this.props.buttonText}
          {modal}
        </Button>
      );
    }

    return content;
  }
}

WallboardConfig.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  dashboardId: PropTypes.string,
  model: PropTypes.object
};

WallboardConfig.defaultProps = {
  visible: false
};

const mapDispatchToProps = dispatch => {
  return {
    handleError: msg => dispatch(handleError(msg)),
    getViews: dashboardId => dispatch(getViews(dashboardId)),
    createSetting: (dashboardId, data) => dispatch(createSetting(dashboardId, data))
  };
};

const mapStateToProps = state => {
  return {
    isLoading: state.wallboards.loading,
    views: state.wallboards.views
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WallboardConfig);
